"use client";

import { useEffect, useState } from "react";
import Image from "next/image";
import { useAppData } from "@/store/appStore";

import { guestLogin } from "@/app/product/_actions/guest.login";
import { hasAuthenticatedSession } from "@/app/product/_actions/auth.actions";
import { syncUserContextFromCookies } from "@/lib/client/faro-manager";
import { getOrCreateDeviceId } from "@/lib/utils/device-id";
import { getUTMData } from "@/lib/utils/utm-tracker";

const GuestLoginInitializer = ({ children }: { children: React.ReactNode }) => {
	const [, setData] = useAppData();
	const [isInitialized, setIsInitialized] = useState(false);

	useEffect(() => {
		const initializeGuestLogin = async () => {
			const isAuthenticated = await hasAuthenticatedSession();

			if (!isAuthenticated) {
				try {
					const deviceId = getOrCreateDeviceId();
					const utmData = getUTMData();
					setData({ deviceId, authorization: "" });
					const response = await guestLogin(deviceId, utmData);

					if (response?.user?.id) {
						localStorage.setItem("guest_user_id", response.user.id);
					}

					// Update observability context after guest login
					try {
						console.debug("Updating observability context after guest login");
						syncUserContextFromCookies();
					} catch (error) {
						console.error(
							"Error syncing user context after guest login:",
							error,
						);
					}
				} catch (error) {
					console.error("Error during guest login:", error);
				}
			}
			setIsInitialized(true);
		};

		initializeGuestLogin();
	}, [setData]);

	if (!isInitialized) {
		return (
			<div className="fixed inset-0 z-50 flex items-center justify-center bg-black px-6">
				<div
					className="relative aspect-square w-full max-w-xs rounded-3xl p-4"
					style={{ width: "min(50vw, 200px)" }}
				>
					<Image
						src="/home/AutoMint.svg"
						alt="Automint"
						fill
						priority
						sizes="(max-width: 768px) 50vw, 200px"
						className="object-contain rounded-2xl"
					/>
				</div>
			</div>
		);
	}

	return <>{children}</>;
};

export default GuestLoginInitializer;
